import React, { createContext, useEffect, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { SpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { getListBarrierStatus } from '../services'
import { IBarrierStatus, IBarrierStatusSpecialStatus } from '../types'
import { bowtieTheme } from '../utils/constants'

// import { Container } from './styles';

interface IResumeBarrierGetter {
    name: string
    customName: string
    color: string
    total: number
}

interface BowtieStatusContextProps {
    getBarrierStatusNameById(id: number): string
    getBarrierStatusColorById(id: number): string
    getResumeBarriersLengthAndTypeStatusEventId(ids: number[]): IResumeBarrierGetter[]
}

// export interface IBarrierStatus {
//     id: number
//     name: string
//     colorReference: string
//     priorityOrder: number
//     specialStatus?: SpecialStatus
// }

export const BowtieStatusContext = createContext<BowtieStatusContextProps>({
    getBarrierStatusNameById: (id: number) => 'Unknown',
    getBarrierStatusColorById: (id: number) => bowtieTheme.barrierColors.unknown,
    getResumeBarriersLengthAndTypeStatusEventId: (ids: number[]) => []
})

interface BowtieProviderContextType {
    statusMap: Map<number, IBarrierStatusSpecialStatus>
}

export const BowtieStatusContextProvider: React.FC<BowtieProviderContextType> = ({ children, statusMap }) => {
    // const [statusMap, setStatusMap] = useState<Map<number, IBarrierStatusSpecialStatus>>(new Map())

    function getBarrierStatusNameById(id: number): string {
        if (!statusMap.has(id)) {
            return 'Unknown'
        }

        const status = statusMap.get(id)
        if (status.statusCustomName) {
            return status.statusCustomName
        }

        return status.name
    }

    function getBarrierStatusColorById(id: number): string {
        if (!statusMap.has(id)) {
            return bowtieTheme.barrierColors.unknown
        }

        const status = statusMap.get(id)

        return status.colorReference
    }

    function getResumeBarriersLengthAndTypeStatusEventId(statusList: number[]): IResumeBarrierGetter[] {
        const statusCount: IResumeBarrierGetter[] = []
        statusMap.forEach(statusItem => {
            if (statusItem.specialStatus !== SpecialStatus.UNMONITORED) {
                statusCount.push({
                    name: statusItem.name,
                    customName: statusItem.statusCustomName,
                    color: statusItem.colorReference,
                    total: statusList.filter(el => el === statusItem.id)?.length ?? 0
                })
            }
        })

        return statusCount
    }

    return (
        <BowtieStatusContext.Provider
            value={{ getBarrierStatusNameById, getBarrierStatusColorById, getResumeBarriersLengthAndTypeStatusEventId }}
        >
            {children}
        </BowtieStatusContext.Provider>
    )
}
